import styles from "../addtuyaaccount.module.css";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button, FormControl, InputLabel, MenuItem, Select, TextField, Autocomplete } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { Link2 } from "react-feather";

const schema = yup.object().shape({
    type: yup.string().required("This field is Required"),
    property_id: yup.string().when("type", (type) => {
        if (type && type === "Tuya")
            return yup.string().required("This field is Required");
        else
            return yup.string();
    }),
    apt_id: yup.string().when("type", (type) => {
        if (type && type === "Tuya")
            return yup.string().required("This field is Required").nullable();
        else
            return yup.string().nullable();
    }),
    name: yup.string().required("This field is Required"),
    email: yup.string().required("This field is Required"),
    project_id: yup.string().when("type", (type) => {
        if (type && type === "Tuya")
            return yup.string().required("This field is Required");
        else
            return yup.string();
    }),
    uid: yup.string().when("type", (type) => {
        if (type && type === "Tuya")
            return yup.string().required("This field is Required");
        else
            return yup.string();
    }),
    password: yup.string().when("type", (type) => {
        if (type && type === "TTLock")
            return yup.string().required("This field is Required");
        else
            return yup.string();
    }),
    client_id: yup.string().required("This field is Required"),
    client_secret: yup.string().required("This field is Required")
});

const Step1 = ({ tuyaData, setTuyaData, setStep, propertyList, setShowTuyaAddFormNew, onSubmitLocal, setLoading }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [apartmentList, setApartmentList] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState(0);
    const [iotType, setIotType] = useState('Tuya');
    const [isConnectSuccess, setIsConnectSuccess] = useState(false);
    const [defaultVals, setDefaultVals] = useState({ email: '', project_id: '', uid: '', password: '', client_id: '', client_secret: '' });
    const [currentVals, setCurrentVals] = useState({ email: '', project_id: '', uid: '', password: '', client_id: '', client_secret: '' });

    const { handleSubmit, control, errors, setValue, clearErrors } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
        defaultValues: {
            type: 'Tuya',
            property_id: '',
            apt_id: '',
            name: '',
            email: '',
            project_id: '',
            uid: '',
            client_id: '',
            client_secret: '',
            password: ''
        }
    });

    useEffect(() => {

        if (tuyaData) {
            setValue('property_id', tuyaData?.property_id);
            setValue('name', tuyaData?.name);
            setValue('email', tuyaData?.email);
            setValue('uid', tuyaData?.uid);
            setValue('project_id', tuyaData?.project_id);
            setValue('client_id', tuyaData?.client_id);
            setValue('client_secret', tuyaData?.client_secret);


            let selProperty = propertyList?.filter(i => i.value === tuyaData?.property_id);
            if (selProperty && selProperty.length > 0) {
                setApartmentList(selProperty[0].apartments);
            }
            setValue('apt_id', tuyaData?.apt_id);
        }
    }, [tuyaData, propertyList, setValue]);

    const selectProperty = (e) => {
        setSelectedProperty(e.target.value);
        let apartmentListTemp = [];
        let selProperty = propertyList?.filter(i => i.value === e.target.value);

        if (selProperty && selProperty.length > 0) {
            apartmentListTemp = selProperty[0].apartments;
        }

        setValue('apt_id', '');
        setApartmentList(apartmentListTemp);

        clearErrors();
    }

    const onSubmit = async (data) => {
        if (data?.type === 'TTLock') {
            onSubmitLocal(data);
        } else {
            setTuyaData(data);
            setStep(2);
        }
    }

    useEffect(() => {
        if (iotType === 'Tuya') {
            if (currentVals?.project_id === '' || currentVals?.uid === '' || currentVals?.client_id === '' || currentVals?.client_secret === '') {
                console.log(currentVals);
            } else {
                if (defaultVals?.project_id === currentVals?.project_id && defaultVals?.uid === currentVals?.uid && defaultVals?.client_id === currentVals?.client_id && defaultVals?.client_secret === currentVals?.client_secret) {
                    console.log(currentVals);
                } else {
                    setIsConnectSuccess(false);
                }
            }
        }

        if (iotType === 'TTLock') {
            if (currentVals?.email === '' || currentVals?.password === '' || currentVals?.client_id === '' || currentVals?.client_secret === '') {
                console.log(currentVals);
            } else {
                if (defaultVals?.email === currentVals?.email && defaultVals?.password === currentVals?.password && defaultVals?.client_id === currentVals?.client_id && defaultVals?.client_secret === currentVals?.client_secret) {
                    console.log(currentVals);
                } else {
                    setIsConnectSuccess(false);
                }
            }
        }

    }, [defaultVals, currentVals, iotType]);

    const chkConnection = async () => {
        let data = {};

        if (iotType === 'TTLock') {
            data = { iotType: iotType, email: currentVals?.email, password: currentVals?.password, client_id: currentVals?.client_id, client_secret: currentVals?.client_secret };
        } else {
            data = { iotType: iotType, client_id: currentVals?.client_id, client_secret: currentVals?.client_secret };
        }

        setIsConnectSuccess(false);
        setLoading(true);

        console.log(111111);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        await axios.post(process.env.REACT_APP_DEVICE_API_URL + "v1/check-iot-connection", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            console.log(22222222);
            setLoading(false);
            setIsConnectSuccess(true);
            setDefaultVals({ email: currentVals?.email, project_id: currentVals?.project_id, uid: currentVals?.uid, password: currentVals?.password, client_id: currentVals?.client_id, client_secret: currentVals?.client_secret });
        }).catch((error) => {
            console.log(333333333);
            setLoading(false);
            setDefaultVals({ email: currentVals?.email, project_id: currentVals?.project_id, uid: currentVals?.uid, password: currentVals?.password, client_id: currentVals?.client_id, client_secret: currentVals?.client_secret });
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    return (<>
        <div className={`${styles.ModalFormGroupTwo}`}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={`${styles.ReqAddRow}`}>
                    <div className={`${styles.ReqAddFormSec}`}>
                        <div className={`${styles.FormSecRow}`}>
                            <div className={`${styles.FormSec}`}>
                                <div className={`${styles.FormGroupFull} FormGroup`}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Type*</InputLabel>
                                        <Controller
                                            name="type"
                                            control={control}
                                            render={(field) => (
                                                <Select
                                                    label="Type*"
                                                    {...field}
                                                    onChange={(e) => {
                                                        field.onChange(e);
                                                        setIotType(e.target.value);
                                                    }}
                                                >
                                                    <MenuItem value={'Tuya'}>Tuya</MenuItem>
                                                    <MenuItem value={'TTLock'}>TTLock</MenuItem>
                                                </Select>
                                            )}
                                        />
                                    </FormControl>
                                    {errors.type && (<p className={`${styles.ErrorM}`}>{errors.type.message}</p>)}
                                </div>
                            </div>
                        </div>
                        {iotType === 'Tuya' && <div className={`${styles.FormSecRow}`}>
                            <div className={`${styles.FormHalfSec}`}>
                                <div className={`${styles.FormSec}`}>
                                    <div className={`${styles.FormGroupFull} FormGroup`}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">Property*</InputLabel>
                                            <Controller
                                                name="property_id"
                                                control={control}
                                                render={(field) => (
                                                    <Select
                                                        label="Property*"
                                                        {...field}
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            selectProperty(e);
                                                        }}
                                                    >
                                                        {propertyList?.map(i => {
                                                            return <MenuItem value={i?.value}>{i?.label}</MenuItem>
                                                        })}
                                                    </Select>
                                                )}
                                            />
                                        </FormControl>
                                        {errors.property_id && (<p className={`${styles.ErrorM}`}>{errors.property_id.message}</p>)}
                                    </div>
                                </div>
                            </div>
                            <div className={`${styles.FormHalfSec}`}>
                                <div className={`${styles.FormSec}`}>
                                    <div className={`${styles.FormGroupFull} FormGroup`}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name="apt_id"
                                                control={control}
                                                render={(field) => (<Autocomplete
                                                    options={apartmentList || []}
                                                    getOptionLabel={(option) => option.label || ""}
                                                    value={apartmentList?.find((opt) => opt.value === field.value) || null}
                                                    renderInput={(params) => (<TextField {...params} label="Select Apartment*" />)}
                                                    noOptionsText={selectedProperty ? "No apartments found" : "Select property first"}
                                                    onChange={(event, newValue) => {
                                                        field.onChange(newValue?.value || null);
                                                        clearErrors("apt_id");
                                                    }}
                                                />)}
                                            />
                                        </FormControl>
                                        {errors.apt_id && (<p className={`${styles.ErrorM}`}>{errors.apt_id.message}</p>)}
                                    </div>
                                </div>
                            </div>
                        </div>}
                        <div className={`${styles.FormSecRow}`}>
                            <div className={`${styles.FormHalfSec}`}>
                                <div className={`${styles.FormSec}`}>
                                    <div className={`${styles.FormGroupFull} FormGroup`}>
                                        <Controller
                                            name={`name`}
                                            control={control}
                                            render={(field) => (
                                                <TextField
                                                    {...field}
                                                    id="outlined-multiline-static"
                                                    label="Project Name*"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                        {errors.name && (<p className={`${styles.ErrorM}`}>{errors?.name?.message}</p>)}
                                    </div>
                                </div>
                            </div>
                            <div className={`${styles.FormHalfSec}`}>
                                <div className={`${styles.FormSec}`}>
                                    <div className={`${styles.FormGroupFull} FormGroup`}>
                                        <Controller
                                            name={`email`}
                                            control={control}
                                            render={(field) => (
                                                <TextField
                                                    {...field}
                                                    id="outlined-multiline-static"
                                                    label="Email*"
                                                    variant="outlined"
                                                    onChange={(e) => {
                                                        field.onChange(e);
                                                        setCurrentVals(prev => {
                                                            return { ...prev, email: e.target.value }
                                                        });
                                                    }}
                                                />
                                            )}
                                        />
                                        {errors.email && (<p className={`${styles.ErrorM}`}>{errors?.email?.message}</p>)}
                                    </div>
                                </div>
                            </div>

                            {iotType === 'TTLock' && <div className={`${styles.FormSec}`}>
                                <div className={`${styles.FormGroupFull} FormGroup`}>
                                    <Controller
                                        name={`password`}
                                        control={control}
                                        render={(field) => (
                                            <TextField
                                                {...field}
                                                id="outlined-multiline-static"
                                                label="Password*"
                                                variant="outlined"
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    setCurrentVals(prev => {
                                                        return { ...prev, password: e.target.value }
                                                    });
                                                }}
                                            />
                                        )}
                                    />
                                    {errors.password && (<p className={`${styles.ErrorM}`}>{errors?.password?.message}</p>)}
                                </div>
                            </div>}
                        </div>
                        <div className={`${styles.iotSeperateSec}`}>
                            {iotType === 'Tuya' && <div className={`${styles.FormSecRow}`}>
                                <div className={`${styles.FormHalfSec}`}>
                                    <div className={`${styles.FormSec}`}>
                                        <div className={`${styles.FormGroupFull} FormGroup`}>
                                            <Controller
                                                name={`project_id`}
                                                control={control}
                                                render={(field) => (
                                                    <TextField
                                                        {...field}
                                                        id="outlined-multiline-static"
                                                        label="Project ID*"
                                                        variant="outlined"
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            setCurrentVals(prev => {
                                                                return { ...prev, project_id: e.target.value }
                                                            });
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors.project_id && (<p className={`${styles.ErrorM}`}>{errors?.project_id?.message}</p>)}
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.FormHalfSec}`}>
                                    <div className={`${styles.FormSec}`}>
                                        <div className={`${styles.FormGroupFull} FormGroup`}>
                                            <Controller
                                                name={`uid`}
                                                control={control}
                                                render={(field) => (
                                                    <TextField
                                                        {...field}
                                                        id="outlined-multiline-static"
                                                        label="UID*"
                                                        variant="outlined"
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            setCurrentVals(prev => {
                                                                return { ...prev, uid: e.target.value }
                                                            });
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors.uid && (<p className={`${styles.ErrorM}`}>{errors?.uid?.message}</p>)}
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            <div className={`${styles.FormSecRow}`}>
                                <div className={`${styles.FormHalfSec}`}>
                                    <div className={`${styles.FormSec}`}>
                                        <div className={`${styles.FormGroupFull} FormGroup`}>
                                            <Controller
                                                name={`client_id`}
                                                control={control}
                                                render={(field) => (
                                                    <TextField
                                                        {...field}
                                                        id="outlined-multiline-static"
                                                        label="Client ID*"
                                                        variant="outlined"
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            setCurrentVals(prev => {
                                                                return { ...prev, client_id: e.target.value }
                                                            });
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors.client_id && (<p className={`${styles.ErrorM}`}>{errors?.client_id?.message}</p>)}
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.FormHalfSec}`}>
                                    <div className={`${styles.FormSec}`}>
                                        <div className={`${styles.FormGroupFull} FormGroup`}>
                                            <Controller
                                                name={`client_secret`}
                                                control={control}
                                                render={(field) => (
                                                    <TextField
                                                        {...field}
                                                        id="outlined-multiline-static"
                                                        label="Client Secret*"
                                                        variant="outlined"
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            setCurrentVals(prev => {
                                                                return { ...prev, client_secret: e.target.value }
                                                            });
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors.client_secret && (<p className={`${styles.ErrorM}`}>{errors?.client_secret?.message}</p>)}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {isConnectSuccess && <p className={`${styles.iotSccSuccessSMS}`}><img src="/static/img/success-img.svg" alt="" />Account successfully connected.</p>}
                            {!isConnectSuccess && <button type="button" onClick={(e) => chkConnection()} className={`${styles.IotConnectBU}`}><Link2 />Connect</button>}
                        </div>
                    </div>
                </div>


                <div className={`${styles.ButtonAction}`}>
                    <Button onClick={(e) => setShowTuyaAddFormNew(false)} type="button" className="CancelPopupBU">Cancel</Button>
                    <Button type="submit" className="SubmitPopupBU" disabled={!isConnectSuccess}>Next</Button>
                </div>
            </form>
        </div>

    </>);
};

export default Step1;